export default __webpack_public_path__ + "static/media/destroyed_37@2x.f92d197a.png";